import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import Input from 'components/Input';
// import Lock from 'assets/svgs/lock-icon.svg';
import toast from 'react-hot-toast';
import { useManualSetPassword } from './manualAuth';
import passwordValidator from '../../../utils/passwordValidator';
import styles from './forgotpassword.module.css';
// import './Manual.scss';

const ForgotPassword = ({ email, passwordFlow }) => {
  const toastId = 'JP238MD02';
  const [data, setData] = useState({
    password: '',
    confirmPassword: '',
  });

  const setPassword = useManualSetPassword();

  useEffect(
    () => () => {
      toast.dismiss();
      setData({
        password: '',
        confirmPassword: '',
      });
    },
    []
  );

  const handleChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // if (!privacyPolicyCheck) {
    //   toast.error('Please check the terms and privacy policy', { id: toastId });
    //   return false;
    // }
    if (data.password === data.confirmPassword) {
      if (passwordValidator(data.password, data.confirmPassword)) {
        if (passwordFlow) {
          setPassword({
            password: data.password,
            email,
          });
        }
      } else
        toast.error(
          'Password should be at least 8 characters long (At least 1 lowercase and uppercase alphabet, 1 numeric and 1 special character)',
          { id: toastId, duration: 20 * 1000 }
        );
    } else {
      toast.error("Password and confirm password doesn't match", {
        id: toastId,
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className={styles.ManualAuth__title}>Reset Password</h3>
      <input
        name="password"
        label="Password"
        placeholder="Password"
        type="password"
        value={data.password}
        className={styles.ManualAuth__input}
        onChange={handleChange}
      />
      <input
        name="confirmPassword"
        label="Confirm password"
        placeholder="Confirm password"
        type="password"
        value={data.confirmPassword}
        className={styles.ManualAuth__input}
        onChange={handleChange}
      />

      <div className={styles['ManualAuth__login-action']}>
        <input
          className={styles['ManualAuth__btn--login']}
          type="submit"
          value="Reset password"
        />
      </div>
    </form>
  );
};

ForgotPassword.propTypes = {
  email: PropTypes.node.isRequired,
  passwordFlow: PropTypes.node.isRequired,
};

export default ForgotPassword;
